import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from 'src/app/service/translation.service';
import { translation } from 'src/environments/translation';

@Component({
  selector: 'app-app-online-payment-success',
  templateUrl: './app-online-payment-success.component.html',
  styleUrls: ['./app-online-payment-success.component.scss']
})
export class AppOnlinePaymentSuccessComponent implements OnInit {
  membershipNo:any;
  firstName:any;
  selectedStore:any;
translation:any;
  constructor(private translationService: TranslationService,private router: Router, private aRoute: ActivatedRoute) { }

  ngOnInit(): void {
    const translationAll = this.translationService.getAll(); 
    if (translationAll.en) {
      this.translation = translationAll.en;
    } 
    else {
      console.warn('English translations not found');
    }

    this.aRoute.queryParams.subscribe((dataFromUrl) => {
      console.log(dataFromUrl);
      this.membershipNo = dataFromUrl['MembershipNo'];
      this.firstName = dataFromUrl['CustomerName'];
    });
  }

  selectAppLink(store){
    this.selectedStore = store;
  }

  goToHomePage(){
    window.location.href = 'https://in2fitness.sa';
  }

}
